import { Route } from "react-router-dom";

import { routes } from "constants/routes";
import HomeCardSettings from "features/main/Home/CardSettings";
import Home from "features/main/Home/Notification";

export default function HomeRoutes() {
  return (
    <Route path={routes.HOME}>
      <Route path="" element={<Home />} />
      <Route path="card-settings" element={<HomeCardSettings />} />
    </Route>
  );
}
